import { uploadRepositories } from 'repositories/upload';

const uploadImage = async (id: number, data: FormData) => {
  const res = await uploadRepositories.uploadImage({
    body: data,
    condition: {
      templateId: id,
    },
  });

  if (res instanceof Error) {
    throw res;
  }

  return res.data;
};

const uploadQuestionImage = async (id: number, data: FormData, stepNo: number) => {
  const res = await uploadRepositories.uploadQuestionImage({
    body: data,
    condition: {
      templateId: id,
      step: stepNo,
    },
  });

  if (res instanceof Error) {
    throw res;
  }

  return res.data;
};

export const uploadServices = {
  uploadImage,
  uploadQuestionImage,
};
